import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Col, Form, Row, Typography,
} from 'antd';
import Select from 'components/Select';

const { Title } = Typography;

const Requisitos = ({
  selectedRow,
  callbackInformation,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (selectedRow) {
      setData(selectedRow);
    }
  }, [selectedRow]);

  return (
    <div style={{ marginTop: '15px' }}>
      <Form
        layout="vertical"
        onFinish={callbackInformation}
        initialValues={data}
      >
        <Title level={4}>FORMATOS</Title>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
        </Row>
        <Title level={4}>PROCEDIMIENTO DE LA INSPECCIÓN</Title>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
        </Row>
        <Title level={4}>¿A QUIÉN SE APLICA?</Title>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="¿Requiere firma?" name="Inspeccionado_debe_firmar_o_generar_doc">
              <Select trueFalse />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

Requisitos.propTypes = {
  selectedRow: PropTypes.shape({}),
  callbackInformation: PropTypes.func,
};

Requisitos.defaultProps = {
  selectedRow: {},
  callbackInformation: () => {},
};

export default Requisitos;
